import React from "react";
import PropTypes from "prop-types";
import FileListSectionV1 from "./FileListSectionV1";
import FileListSectionV2 from "./FileListSectionV2";

export const FileListSectionVersion = {
  v1: "v1",
  v2: "v2",
};

export function FileListSection({ version, ...props }) {
  if (version === FileListSectionVersion.v1) {
    return <FileListSectionV1 {...props} />;
  }

  return <FileListSectionV2 {...props} />;
}

FileListSection.propTypes = {
  version: PropTypes.oneOf([
    FileListSectionVersion.v1,
    FileListSectionVersion.v2,
  ]),
  label: PropTypes.string,
  showArchiveLabel: PropTypes.string,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      version: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    }),
  ),
  archivedFiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      version: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    }),
  ),
  onArchive: PropTypes.func,
  onUnarchive: PropTypes.func,
  onRemoveArchived: PropTypes.func,
  showArchive: PropTypes.bool,
  onToggleShowArchive: PropTypes.func,
};

FileListSection.defaultProps = {
  version: FileListSectionVersion.v2,
  label: "Files",
  showArchiveLabel: "Show Archive",
  files: [],
  archivedFiles: [],
  onArchive: () => {},
  onUnarchive: () => {},
  onRemoveArchived: () => {},
  showArchive: false,
  onToggleShowArchive: () => {},
};

export default FileListSection;
